import createAboPaths from './abo-paths';

jQuery(function($)
{
    if (
        $('.js-products-slider').length === 0 &&
        $('.js-tilesview-small').length === 0 &&
        $('.js-tilesview').length === 0
    )
    {
        return;
    }

    var $tilesviews = [];
    var $tilesviewItems = $();
    var tilesviewProducts = [];

    let tilesviewFrontsideContainerSelector = '.js-frontside-container';
    let tilesviewFrontsideImageSelector = '.js-hover-frontside-image';
    let tilesviewBacksideContainerSelector = '.js-backside-container';
    let tilesviewBacksideImageSelector = '.js-hover-backside-image';

    var $variationContainer = $('.js-tilesview-variation-container');
    var $variationOverlayContainer = $('.js-tilesview-variation-overlay-container');
    var $variationMoreIndicator = $('.js-more-indicator');
    var $variationList = $('.js-tilesview-variation-list');
    var $variationSelect = $('.js-tilesview-variation-select');

    const productFlags = [
        { flag: 'noveltyFlag', selector: '.js-badge--new' },
        { flag: 'upcomingProductFlag', selector: '.js-badge--upcoming' },
        { flag: 'bargainProductFlag', selector: '.js-badge--discount' },
        { flag: 'expiringProductFlag', selector: '.js-tag--expiring' },
        { flag: 'promotionalPackingFlag', selector: '.js-tag--bulk' },
        { flag: 'posProductFlag', selector: '.js-tag--retail' },
        { flag: 'bestsellerFlag', selector: '.js-badge--bestseller' }
    ];

    function init()
    {
        if ($('.js-products-slider').length > 0)
        {
            $tilesviews.push($('.tns-slider'));
        }

        if ($('.js-tilesview-small').length > 0)
        {
            $tilesviews.push($('.js-tilesview-small'));
        }

        if ($('.js-tilesview').length > 0)
        {
            $tilesviews.push($('.js-tilesview'));
        }

        $tilesviews.forEach(view =>
        {
            $tilesviewItems = $tilesviewItems.add('.js-tilesview-item', view);
        });

        $variationContainer = $('.js-tilesview-variation-container');
        $variationList = $('.js-tilesview-variation-list');
        $variationSelect = $('.js-tilesview-variation-select');

        if ($('li.selected').closest($variationOverlayContainer).length)
        {
            $variationMoreIndicator.addClass('selected');
        }

        initEvents();
        fetchProducts();
    }

    function initEvents()
    {
        $variationList.on('click', handleVariationChange);
        $variationSelect.on('change', handleVariationChange);

        let tilesviewBacksideTriggerElements = document.querySelectorAll('.js-hover-backside-trigger');

        if (
            !document.querySelector('#home')
            && !document.querySelector('#product')
            && tilesviewBacksideTriggerElements
            && orion.getShopViewCode() === 'mobile'
        )
        {
            window.addEventListener('scroll', () =>
            {
                tilesviewBacksideTriggerElements.forEach(trigger =>
                {
                    let rect = trigger.getBoundingClientRect();
                    let viewportHeight = window.innerHeight;

                    let triggerZoneStart = 50;
                    let triggerZoneEnd = viewportHeight / 2;

                    let frontImage = trigger.querySelector(tilesviewFrontsideImageSelector);
                    let backImage = trigger.querySelector(tilesviewBacksideImageSelector);
                    if (backImage)
                    {
                        if (rect.top >= triggerZoneStart && rect.bottom <= triggerZoneEnd)
                        {
                            frontImage.classList.add('hover-animate-flip--front');
                            backImage.classList.remove('hover-animate-flip--back');
                        }
                        else
                        {
                            frontImage.classList.remove('hover-animate-flip--front');
                            backImage.classList.add('hover-animate-flip--back');
                        }
                    }
                });
            });
        }
    }

    function fetchProducts()
    {
        $tilesviewItems.each(function()
        {
            $.extend(tilesviewProducts, $(this).data('products'));
        });
    }

    function updateWatchlistVariation($selectedVariation, $watchlistProductItem)
    {
        $watchlistProductItem.find('.js-watchlist-variation').each(function()
        {
            var $watchlistVariation = $(this);
            var watchlistVariationNumber = $watchlistVariation.data('product-number');
            var selectedProductNumber = $selectedVariation.data('product-number');

            if (selectedProductNumber === watchlistVariationNumber)
            {
                $watchlistVariation.removeClass('hidden');
            }
            else
            {
                $watchlistVariation.addClass('hidden');
            }
        });
    }

    function handleVariationChange(e)
    {
        let $target = $(e.target);
        var $selectedVariation;
        var $watchlistProductItem = $(e.target).closest('.js-product-list-item');

        if ($target.is('span'))
        {
            $selectedVariation = $target;
            $selectedVariation.closest($variationContainer).find('.selected').removeClass('selected');
            $selectedVariation.parent('li').addClass('selected');

            updateWatchlistVariation($selectedVariation, $watchlistProductItem);
        }
        else if ($target.is('select'))
        {
            $selectedVariation = $(e.target).find(':selected');
            updateWatchlistVariation($selectedVariation, $watchlistProductItem);
        }
        else
        {
            return;
        }

        var selectedProductNumber = $selectedVariation.data('product-number');
        var availabilityClass;

        var $currentTile = $(this).closest('.js-tilesview-item');

        var currentProductNumber = $currentTile.attr('data-product-number');

        $currentTile.attr('data-product-number', tilesviewProducts[selectedProductNumber].productNumber);

        $currentTile.find('.sku').text(tilesviewProducts[selectedProductNumber].productNumber);
        $currentTile.find('.name a').text(tilesviewProducts[selectedProductNumber].productName);

        const originalSrc = tilesviewProducts[selectedProductNumber].productImage.trim();

        const aboPaths = createAboPaths(originalSrc);

        $currentTile.find('.image-wrapper ' + tilesviewFrontsideContainerSelector + ' img')
            .attr('src', aboPaths.original);
        $currentTile.find('.image-wrapper ' + tilesviewFrontsideContainerSelector + ' source[type="image/avif"]')
            .attr('srcset', aboPaths.avifImage + ', ' + aboPaths.avifRetinaImage + ' 2x');
        $currentTile.find('.image-wrapper ' + tilesviewFrontsideContainerSelector + ' source[type="image/webp"]')
            .attr('srcset', aboPaths.webPImage + ', ' + aboPaths.webPRetinaImage + ' 2x');
        $currentTile.find('.image-wrapper ' + tilesviewFrontsideContainerSelector + ' source[type="image/jpeg"]')
            .attr('srcset', aboPaths.jpgImage + ', ' + aboPaths.jpgRetinaImage + ' 2x');

        if (tilesviewProducts[selectedProductNumber].productAlternateImage)
        {
            const originalBackSrc = tilesviewProducts[selectedProductNumber].productAlternateImage.trim();

            const aboBackPaths = createAboPaths(originalBackSrc);

            $currentTile.find('.image-wrapper ' + tilesviewBacksideContainerSelector + ' img')
                .attr('src', aboBackPaths.original);
            $currentTile.find('.image-wrapper ' + tilesviewBacksideContainerSelector + ' source[type="image/avif"]')
                .attr('srcset', aboBackPaths.avifImage + ', ' + aboBackPaths.avifRetinaImage + ' 2x');
            $currentTile.find('.image-wrapper ' + tilesviewBacksideContainerSelector + ' source[type="image/webp"]')
                .attr('srcset', aboBackPaths.webPImage + ', ' + aboBackPaths.webPRetinaImage + ' 2x');
            $currentTile.find('.image-wrapper ' + tilesviewBacksideContainerSelector + ' source[type="image/jpeg"]')
                .attr('srcset', aboBackPaths.jpgImage + ', ' + aboBackPaths.jpgRetinaImage + ' 2x');

            // class for product variations that have no back side. Is hidden in the CSS
            $currentTile.find(tilesviewFrontsideImageSelector).removeClass('hover-animate-flip--front--none');
            $currentTile.find(tilesviewBacksideImageSelector).removeClass('hover-animate-flip--back--none');
        }
        else
        {
            // class for product variations that have no back side. Is hidden in the CSS
            $currentTile.find(tilesviewFrontsideImageSelector).addClass('hover-animate-flip--front--none');
            $currentTile.find(tilesviewBacksideImageSelector).addClass('hover-animate-flip--back--none');
        }

        if (tilesviewProducts[selectedProductNumber].productPriceAuthorized !== undefined)
        {
            $currentTile.find('.js-tilesview-price-authorized')
                .text(tilesviewProducts[selectedProductNumber].productPriceAuthorized);
        }
        if (tilesviewProducts[selectedProductNumber].productStrikePrice !== undefined)
        {
            $currentTile.find('.js-tilesview-price-strike').removeClass('hidden');
            $currentTile.find('.js-tilesview-price-strike--value')
                .text(tilesviewProducts[selectedProductNumber].productStrikePrice);
        }
        else
        {
            $currentTile.find('.js-tilesview-price-strike').addClass('hidden');
            $currentTile.find('.js-tilesview-price-strike--value').text('');
        }

        $currentTile.find('.js-tilesview-price-public')
            .text(tilesviewProducts[selectedProductNumber].productSuggestedRetailPrice);

        $currentTile.find('.choise input').attr('id', tilesviewProducts[selectedProductNumber].productNumber);

        $currentTile.find('input[name=quantity]').attr('data-product-number',
            tilesviewProducts[selectedProductNumber].productNumber);

        $currentTile.find('input[name=quantity]').attr('id',
            tilesviewProducts[selectedProductNumber].productNumber + '-quantity');

        $currentTile.find('.js-overlay-shoppinglist-open-button')
            .attr('data-product-number', tilesviewProducts[selectedProductNumber].productNumber);

        var $overlayDataElement = $currentTile.find('[id*=shoppinglist-overlay-data]');

        $overlayDataElement
            .attr('id', 'shoppinglist-overlay-data-' + tilesviewProducts[selectedProductNumber].productNumber);
        $overlayDataElement.attr('data-productnumber', tilesviewProducts[selectedProductNumber].productNumber);
        $overlayDataElement.attr('data-producttitle', tilesviewProducts[selectedProductNumber].productName);
        $overlayDataElement.attr('data-productvariation', tilesviewProducts[selectedProductNumber].productVariation);
        $overlayDataElement.attr('data-productimage', tilesviewProducts[selectedProductNumber].productImage);

        var $detailsLink;
        var productDetailsUrl;

        if (
            $target.closest('.products-slider').length > 0 ||
            $target.closest('.js-tilesview-small').length > 0 ||
            $target.closest('.js-tilesview').length > 0
        )
        {
            $detailsLink = $currentTile.find('.js-tilesview-details-link');
            productDetailsUrl = new URI($detailsLink.attr('href'));

            productDetailsUrl.path(tilesviewProducts[selectedProductNumber].productUrl);
            $detailsLink.attr('href', productDetailsUrl.href());
        }

        productFlags.forEach(({ flag, selector }) =>
        {
            if (tilesviewProducts[selectedProductNumber][flag] !== undefined)
            {
                $currentTile.find(selector).toggleClass('hidden', !tilesviewProducts[selectedProductNumber][flag]);
            }
        });

        if (tilesviewProducts[selectedProductNumber].productAvailable == 1)
        {
            availabilityClass = 'in-stock';
        }
        else
        {
            availabilityClass = 'out-of-stock';
        }

        var $availability = $(this).parents('.item-container')
            .find('.details-container .availability');

        $availability.removeClass('in-stock out-of-stock');
        $availability.addClass(availabilityClass);

        $selectedVariation.removeClass('in-stock out-of-stock');
        $selectedVariation.addClass(availabilityClass);

        // we need an event on the body for the pils components
        let variationChangedEvent = new CustomEvent(
            orion.constants.EventTilesviewVariationChanged,
            {
                bubbles: true,
                detail: {
                    currentProductNumber: currentProductNumber,
                    selectedProductNumber: selectedProductNumber
                }
            }
        );

        let $promotionTagElement = $currentTile.find('.js-promotion-tag');

        if ($promotionTagElement.length) handlePromotionTag($promotionTagElement, selectedProductNumber);

        $currentTile.get(0).dispatchEvent(variationChangedEvent);
    }

    function handlePromotionTag($promotionTagElement, selectedProductNumber)
    {
        let promotionProductNumbers = String($promotionTagElement.data('product-number-list')).split(',').map(Number);

        if (promotionProductNumbers.includes(Number(selectedProductNumber)))
        {
            $promotionTagElement.removeClass('hidden');
        }
        else
        {
            $promotionTagElement.addClass('hidden');
        }
    }

    $('#content').on(orion.constants.EventProductListReloaded, init);

    init();
});
